<script lang="ts">
    import type {IntegrationSyncTypeStatus} from '$lib/models/integration/integration';

    export let syncTypes: IntegrationSyncTypeStatus[];
</script>

{#if syncTypes.length === 0}
  <div class="text-sm text-gray-600 mb-2">No sync types available for this entity.</div>
{:else}
  <table class="w-full text-sm text-left border border-gray-200 rounded">
    <thead class="bg-gray-50 font-semibold border-b border-gray-200">
      <tr>
        <th class="px-3 py-2">Sync Type</th>
        <th class="px-3 py-2">Status</th>
      </tr>
    </thead>
    <tbody>
      {#each syncTypes as sync, index (index)}
        <tr class="border-b border-gray-100 hover:bg-gray-50" class:opacity-25={!sync.isActive}>
          <td class="px-3 py-2">{sync.syncTypeName}</td>
          <td class="px-3 py-2 flex items-center gap-2">
            {#if sync.isActive}
              <span class="font-bold">On</span>
            {:else}
              <span class="font-medium">Off</span>
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{/if}
